<spinner [isRunning]="showSpinner"></spinner>
<div #maincontainer class="main-container scroll-container">

  <!-- Top progress bar -->
  <mat-progress-bar *ngIf="isLoadingMoreRecords" mode="indeterminate" class="top-progress-bar"></mat-progress-bar>

  <!-- Desktop header -->
  <div class="header-bar desktop-header">
    <div class="header-items">
      <div class="header-layout">
        <mat-checkbox class="header-notes-filter" color="accent"
          [(ngModel)]="listSearchData.hasNotes" (change)="filterChanged('sortBy')">Chat</mat-checkbox>

        <div class="header-filters">
          <mat-form-field class="header-sort-by" appearance="fill">
            <mat-label>Sort By</mat-label>
            <mat-select [(ngModel)]="listSearchData.sortBy" (selectionChange)="filterChanged('sortBy')">
              <mat-option *ngFor="let sort of sortByLookup" [value]="sort.id">{{ sort.name }}</mat-option>
            </mat-select>
          </mat-form-field>

          <button mat-icon-button (click)="filterChanged('sortOrder')" matTooltip="sort direction" matTooltipPosition="below">
            <mat-icon>{{ sortOrderIcon }}</mat-icon>
          </button>

          <mat-form-field class="header-status" appearance="fill">
            <mat-label>Filter by Status</mat-label>
            <mat-select [(ngModel)]="listSearchData.status" (selectionChange)="filterChanged('status')">
              <mat-option *ngFor="let stat of statusLookup" [value]="stat.name">{{ stat.name }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="header-filter-by" appearance="fill">
            <mat-label>Search By</mat-label>
            <mat-select [(ngModel)]="listSearchData.filterBy">
              <mat-option *ngFor="let filter of filterByLookup" [value]="filter.id">{{ filter.name }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="header-search" appearance="fill">
            <mat-label>Search</mat-label>
            <input matInput [(ngModel)]="listSearchData.filterString" (keyup.enter)="filterChanged('sortBy')">
          </mat-form-field>

          <button mat-icon-button (click)="filterChanged('clear')" matTooltip="clear search" matTooltipPosition="below">
            <mat-icon>clear</mat-icon>
          </button>
        </div>

        <div class="header-actions-row">
          <div class="select-all-block">
            <mat-checkbox class="header-select-all-filter" color="accent"
              (change)="selectAllItems($event)" [checked]="allItemsSelected">Select All</mat-checkbox>
          </div>
          <div class="select-all-block">
            <button mat-button type="button" class="export-list-btn" (click)="generateReport()">Export List</button>
          </div>
          <span class="spacer"></span>
          <div class="action-items">
            <bulk-bar *ngIf="anyItemSelected() && !_authService.readOnly && !isMobileLayout" [backActionVisible]="false"
              [projectId]="listSearchData.projectId" [itemList]="itemList" [isClearanceUser]="isClearanceUser"
              (ModalInitializationRequested)="onModalInitRequest($event)" [downloadButtonVisible]="false"></bulk-bar>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Mobile header -->
  <div class="header-bar mobile-header">
    <div class="mobile-header-row">
      <mat-checkbox color="accent" (change)="selectAllItems($event)" [checked]="allItemsSelected">Select All</mat-checkbox>
      <button mat-button type="button" class="export-list-btn" (click)="generateReport()">Export List</button>
      <span class="spacer"></span>
      <button mat-icon-button (click)="showMobileFilters = !showMobileFilters" matTooltip="expand filters" matTooltipPosition="below">
        <mat-icon>search</mat-icon>
      </button>
      <div class="action-items" *ngIf="anyItemSelected() && !_authService.readOnly && isMobileLayout">
        <bulk-bar [backActionVisible]="false" [projectId]="listSearchData.projectId" [itemList]="itemList"
          [isClearanceUser]="isClearanceUser" (ModalInitializationRequested)="onModalInitRequest($event)"
          [downloadButtonVisible]="false"></bulk-bar>
      </div>
    </div>
    <div class="mobile-filters" *ngIf="showMobileFilters">
      <mat-checkbox color="accent" [(ngModel)]="listSearchData.hasNotes" (change)="filterChanged('sortBy')">Chat</mat-checkbox>
      <mat-form-field appearance="fill">
        <mat-label>Sort By</mat-label>
        <mat-select [(ngModel)]="listSearchData.sortBy" (selectionChange)="filterChanged('sortBy')">
          <mat-option *ngFor="let sort of sortByLookup" [value]="sort.id">{{ sort.name }}</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-icon-button (click)="filterChanged('sortOrder')" matTooltip="sort direction" matTooltipPosition="below">
        <mat-icon>{{ sortOrderIcon }}</mat-icon>
      </button>
      <mat-form-field appearance="fill">
        <mat-label>Filter by Status</mat-label>
        <mat-select [(ngModel)]="listSearchData.status" (selectionChange)="filterChanged('status')">
          <mat-option *ngFor="let stat of statusLookup" [value]="stat.name">{{ stat.name }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Search By</mat-label>
        <mat-select [(ngModel)]="listSearchData.filterBy">
          <mat-option *ngFor="let filter of filterByLookup" [value]="filter.id">{{ filter.name }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Search</mat-label>
        <input matInput [(ngModel)]="listSearchData.filterString" (keyup.enter)="filterChanged('sortBy')">
      </mat-form-field>
      <button mat-icon-button (click)="filterChanged('clear')" matTooltip="clear search" matTooltipPosition="below">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>

  <!-- No results message -->
  <div *ngIf="itemList.length <= 0" class="subheader">
    <mat-icon *ngIf="inErrorState" class="subheader-icon">error</mat-icon>
    <span>{{ searchMessage }}</span>
  </div>

  <!-- Item cards grid -->
  <div class="cards-grid">
    <mat-card *ngFor="let item of itemList" class="list-view-card">
      <mat-card-content (click)="openItemDetails(item.id)">
        <div class="card-layout">

          <!-- Thumbnail -->
          <div class="list-thumbnail" (click)="openCarousel(item, $event)">
            <mat-icon *ngIf="!item.defaultImage" class="no-image-icon">image</mat-icon>
            <div *ngIf="item.defaultImage" class="photo-stack" (click)="openCarousel(item, $event)">
              <img *ngIf="item.defaultImage" [src]="item.defaultImage.fullUrl" alt="" (load)="loadFinished($event)"
                (error)="hideBrokenImage($event)" (click)="openCarousel(item, $event)" />
              <img *ngFor="let rimage of item.defaultImage.relatedImages" [src]="rimage.fullUrl"
                (error)="hideBrokenImage($event)" (click)="openCarousel(item, $event)" />
            </div>
          </div>

          <!-- Item details -->
          <div class="item-details">
            <div class="title nowrapping">
              {{ item.name }}
            </div>
            <div class="status nowrapping" [ngClass]="item.statusClass">
              {{ item.status }}
            </div>
            <div class="detail-meta">
              <div class="detail-meta-col detail-meta-col-left">
                <div class="copyright nowrapping">
                  <mat-icon>copyright</mat-icon><span>{{ item.copyrightInfo }}</span>
                </div>
                <div class="author nowrapping">
                  <mat-icon>accessibility</mat-icon><span>{{ item.artistAuthorName }}</span>
                </div>
                <div class="reportgroup nowrapping" *ngIf="isClearanceUser">
                  <mat-icon>wb_incandescent</mat-icon><span>{{ item.reportGroupName }}</span>
                </div>
                <div class="reportgroup nowrapping" *ngIf="(projectDepartment == 'TV Animation' || projectDepartment == 'TV') && item.fonts">
                  <mat-icon>text_fields</mat-icon><span>{{ item.fonts }}</span>
                </div>
                <div *ngIf="item.hasNotes" class="notes-indicator">
                  <mat-icon class="notes-icon">comment</mat-icon>
                </div>
              </div>
              <div class="detail-meta-col detail-meta-col-right">
                <div class="deadline nowrapping">
                  <mat-icon>alarm_on</mat-icon><span>{{ item.deadline }}</span>
                </div>
                <div class="deadline nowrapping" *ngIf="item.season">
                  <mat-icon>movie</mat-icon><span>{{ item.season }}</span>
                </div>
                <div class="deadline nowrapping" *ngIf="item.episode">
                  <mat-icon>theaters</mat-icon><span>{{ item.episode }}</span>
                </div>
                <div class="item-number nowrapping">
                  <span class="unique-id">#</span><span>{{ item.ciUniqueId }}</span>
                </div>
                <div *ngIf="item.hasCINotes" class="notes-indicator">
                  <span class="chat-pill">
                    <mat-icon class="chat-pill-icon">chat_bubble</mat-icon>
                    <span *ngIf="item.unreadNotesCount > 0" class="ci-chat-unread-badge">{{ item.unreadNotesCount }}</span>
                  </span>
                </div>
              </div>
            </div>
            <div class="tag-list nowrapping hoverable" (click)="showAllTags(item); stopPropagation($event)">
              <div class="tag" *ngFor="let tag of item.tags">{{ tag.tagName }}</div>
            </div>
          </div>

          <!-- Checkbox + alternate titles (STG: link icon aligned with checkbox column) -->
          <div class="item-select" *ngIf="!_authService.readOnly || moreTitlesVisible(item)">
            <a *ngIf="moreTitlesVisible(item)" class="anchor aka-moretitles"
               [matTooltip]="stringTitle(item)" matTooltipPosition="below"
               (click)="$event.stopPropagation()">
              <mat-icon class="more-titles-icon">link</mat-icon>
            </a>
            <mat-checkbox *ngIf="!_authService.readOnly" color="accent" [(ngModel)]="item.isSelected"
              (click)="stopPropagation($event)"></mat-checkbox>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Loading more -->
  <div *ngIf="isLoadingMoreRecords" class="loading-more">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    <h4>Loading More Items...</h4>
  </div>

  <carousel *ngIf="showCarousel" [images]="carouselImages" [showSpinner]="false" [index]="currentCarouselIndex"
    [loop]="true" [projectId]="listSearchData.projectId" [dataImages]="dataImages"
    [hideReportDefaultIcons]="true" [preventRemoval]="true" [itemList]="completeitemList"
    [currentCiName]="currentCarouselCiName" [statusLookup]="modalstatusLookup"
    [currentCiStatus]="currentCiStatus" [currentCiStatusComments]="currentCiStatusComments"
    [projectDepartment]="projectDepartment" (onCIStatusChanged)="ciStatusChange($event)"
    (onClose)="closeCarousel($event)" [ciListQueryString]="currentQueryString"
    (onSaveDetails)="updateImageDetails($event)"></carousel>
</div>

<bulk-actions #bulkAction [modalId]="currentBulkModalId" [projectId]="listSearchData.projectId"
  [itemList]="itemList" [dataList]="bulkDataList" [isClearanceUser]="isClearanceUser"></bulk-actions>

<!-- Tags modal (inline overlay) -->
<div class="tags-modal-overlay" *ngIf="showTagsModal" (click)="showTagsModal = false">
  <div class="tags-modal-content" (click)="stopPropagation($event)">
    <h4>Tags for: {{ selectedItem.name }}</h4>
    <mat-card>
      <mat-card-content>
        <div class="tag-list">
          <div class="tag" *ngFor="let tag of selectedItem.tags">{{ tag.tagName }}</div>
        </div>
      </mat-card-content>
    </mat-card>
    <div class="tags-modal-footer">
      <button mat-button class="btn-flat" (click)="showTagsModal = false">Close</button>
    </div>
  </div>
</div>

<!-- Load More FAB -->
<button mat-fab class="fab-load-more"
        [disabled]="!moreRecords()"
        (click)="manualLoad()"
        matTooltip="load more..." matTooltipPosition="above">
  <mat-icon>expand_more</mat-icon>
</button>

<!-- Create New Item FAB -->
<button mat-fab #newItemFab color="accent" class="fab-new-item"
        *ngIf="!_authService.readOnly"
        (click)="createNewItem()"
        matTooltip="new item" matTooltipPosition="above">
  <mat-icon>add</mat-icon>
</button>
